import { render } from "./AutoWrapping.vue?vue&type=template&id=5327f2df"
import script from "./AutoWrapping.vue?vue&type=script&lang=js"
export * from "./AutoWrapping.vue?vue&type=script&lang=js"
script.render = render

export default script